<div class="container-fluid px-4 pb-4">
    <app-my-score-filter-bar
        [siteDataSource]="siteDataSource"
        [vendorDataSource]="vendorDataSource"
        (filtersChanged)="onFiltersChanged($event)"
        (exportRequested)="onExport()"
    ></app-my-score-filter-bar>

    @for (section of sections; track section.title) {
        <app-doughnut-chart-table
            [title]="section.title"
            [slices]="section.slices"
            [palette]="palette"
            [score]="section.score"
        ></app-doughnut-chart-table>
    }
</div>
